import api from './axiosConfig';
const url = '/api/archivos';

async function obtenerImagen(rutaGuardada) {
  const rutaLimpia = rutaGuardada.replace(/\\/g, '/').replace(/^uploads\//, '');
  
  const response = await api.get(
    `${url}/${rutaLimpia}`, 
    { responseType: 'blob' }
  );

  if (response.status !== 200) {
    throw new Error(`No se pudo obtener la imagen (status ${response.status})`);
  }

  return URL.createObjectURL(response.data);
}

export default obtenerImagen;